export default __webpack_public_path__ + "static/card-2-6757290ce3f86f682cca8793eda38cf6.svg";